<form [formGroup]="form" (ngSubmit)="submit()" class="form-emergency-contact">
  <div class="text-container">
    <div>
      <ion-label class="title">{{ 'onboarding.emergency-contact.instructions' | transloco }} </ion-label>
      @if (hasContact) {
        <div class="card-container">
          <div>
            <ion-label class="contact-label ion-text-wrap">
              <div class="ion-label-inner">{{ fullName }}</div>
            </ion-label>
          </div>
          <div class="icon-container">
            <c-button
              type="secondary"
              size="small"
              [iconOnly]="true"
              [icon]="pencilIcon"
              (action)="initModal()" />
            <c-button
              type="secondary"
              size="small"
              [iconOnly]="true"
              [icon]="trashIcon"
              (action)="clearContact()" />
          </div>
        </div>
      } @else {
        <c-button
          class="add-contact"
          type="secondary"
          [icon]="plusIcon"
          iconPosition="start"
          (action)="initModal()">
          {{ 'onboarding.emergency-contact.add-emergency-contact' | transloco }}
        </c-button>
      }
    </div>
  </div>
  <div class="buttons-container">
    <c-button [loading]="loading" (action)="submit()">{{ 'common.next' | transloco }}</c-button>
  </div>
</form>

